import { render, staticRenderFns } from "./RencamSchedaMorteQuesitiParteTreEditComponent.vue?vue&type=template&id=a47d6524"
import script from "./RencamSchedaMorteQuesitiParteTreEditComponent.vue?vue&type=script&lang=js"
export * from "./RencamSchedaMorteQuesitiParteTreEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports